import { useMutation, useQueryClient } from '@tanstack/react-query';

import { apiClient } from '@cast/infrastructure-api';
import { EvictorAdvancedConfig } from '@cast/types-workload-eviction';

import { getEvictorAdvancedConfigQueryKey } from '../queries/useEvictorAdvancedConfigQuery';

type Args = {
  clusterId: string;
  advancedConfig: EvictorAdvancedConfig;
};

export const useEvictorAdvancedConfigMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (args: Args) =>
      apiClient.workloadEviction.updateAdvancedConfig({
        clusterId: args.clusterId,
        advancedConfig: args.advancedConfig,
      }),
    onSuccess: ({ data: updatedAdvancedConfig }, args) => {
      const queryKey = getEvictorAdvancedConfigQueryKey({
        clusterId: args.clusterId,
      });
      queryClient.setQueryData(queryKey, updatedAdvancedConfig);
    },
  });
};
